import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';

import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import Controller from './module/controller'
import Contact from './module/contact'
import Recruit from './module/recruit'
import Header from './module/header';


//上書き用変数
var Extension = {};

(function ($, Extension) {

	Controller.standby();


	Header.init();

	var Carousel = {

		init: function() {
			if(!$('.top-page').get(0)) {
				return;
			}
			this.view = {};
			this.view.service_list_item = $('.service-list-item');

			Controller.view.window.on('resize:responsive', this.eventChange.bind(this));

			this.view.next_arrow = $('.services-carousel .arrow');
			this.view.next_arrow.on('click', this.next.bind(this));

			this.view.prev_arrow = $('.services-carousel .sp-arrow');
			this.view.prev_arrow.on('click', this.prev.bind(this));
		},
		eventChange: function(){
			if(Controller.device === 'PC') {
				this.view.service_list_item.off('click')
				this.view.service_list_item.on('mouseenter', this.getClassName.bind(this));
			} else {
				this.view.service_list_item.off('mouseenter')
				this.view.service_list_item.on('click', this.getClassName.bind(this));
			}

		},
		getClassName: function(el) {

			var className = $(el.currentTarget).data('target');
			var target = $('.carousel-item').filter(function(){
				return $(this).hasClass(className);
			});
			this.toggle(target);
		},
		toggle: function(target){
			$('.carousel-item').removeClass('is-active');
			target.addClass('is-active');
		},
		next: function(el){
			var next = $('.carousel-item.is-active').next('.carousel-item');
			if(next.length != 0) {
				$('.carousel-item').removeClass('is-active');
				next.addClass('is-active');
			} else {
				$('.carousel-item').removeClass('is-active');
				$('.carousel-item').eq(0).addClass('is-active');
			}

		},
		prev: function() {
			var prev = $('.carousel-item.is-active').prev('.carousel-item');
			if(prev.length != 0) {
				$('.carousel-item').removeClass('is-active');
				prev.addClass('is-active');
			} else {
				$('.carousel-item').removeClass('is-active');
				$('.carousel-item:last-child').addClass('is-active');
			}
		}

	}

	Carousel.init();


	const Panel = {

		init:function(){
			if(!$('.top-page').get(0)) {
				return;
			}
			this.view = {};

			this.view.frontPanel = $('.panel .front');
			this.view.backPanel = $('.panel .back');

			// this.setLogo('back');
			this.loop();

		},
		setLogo: function(className) {

			var logo = ['logo01','logo02','logo03','logo04','logo05','logo06','logo07','logo08','logo09','logo10','logo11','logo12','logo13','logo14','logo15','logo16','logo17',]


			var panels = $('.panel .logo').filter(function(){
				return $(this).hasClass(className);
			});

			$(panels).each(function(i){

				var index = Math.floor(Math.random() * logo.length);
				var choice = logo[index];

				$(this).attr('data-logo', choice).addClass('is-hide');

				logo.splice(index, 1);
			});
		},
		stop: function() {
			clearInterval(this.timer);
			$('.front').dequeue();
			$('.back').dequeue();
		},
		loop: function() {
			this.timer = setInterval(this.fade, 10000);
		},
		fade: function() {
			if($('.front').hasClass('is-hide')){
				$('.front').removeClass('is-hide');
				$('.front').delay(2000).queue(function() {
					$(this).addClass('is-show').dequeue();
				});
			} else {
				$('.front').removeClass('is-show').addClass('is-hide');
			}
			if($('.back').hasClass('is-hide')){
				$('.back').removeClass('is-hide');
				$('.back').delay(2000).queue(function() {
					$(this).addClass('is-show').dequeue();
				});
			} else {
				$('.back').removeClass('is-show').addClass('is-hide');
			}
		},
		flip : function() {

			if($('.panel-inner').hasClass('is-rotateY')) {
				$('.panel-inner').removeClass('is-rotateY').addClass('is-rotateYY');
			} else {
				$('.panel-inner').removeClass('is-rotateYY').addClass('is-rotateY');
			}
		}


	}

	const Parallax = {


		init: function() {
			if(!$('.top-page').get(0)) {
				return;
			}
			this.view = {};
			this.view.clouds = document.querySelectorAll('.move-cloud');
			this.count = $('.move-cloud').length;
			this.flag = true;
			this.controller = null;
			this.cloudScene = null;//現時点の雲
			this.nextCloudScene = null;//次の雲
			Controller.view.window.on('load resize', this.setSence.bind(this));
			// this.setSence(this)
		},
		getHeight: function(el) {
			return $(el).height();
		},
		setSence: function() {
			if(this.nextCloudScene != null || this.cloudScene != null) {
				this.nextCloudScene.destroy(true);
				this.nextCloudScene = null;
				this.cloudScene.destroy(true);
				this.cloudScene = null;
			}

			if(this.nextCloudScene === null || this.cloudScene === null) {

				Array.prototype.slice.call(this.view.clouds).forEach(function (cloud, index) {

					var className = $(cloud).data('move');
					var element = document.getElementsByClassName(className);
					var transform = $(cloud).data('transform');

					$(element).css({
						'transform': 'translate3d(0, 0px ,0)'
					});

					this.cloudScene = new ScrollMagic.Scene({
						triggerElement: cloud,
						triggerHook: 'onCenter',
						duration: this.getHeight(cloud)

					})
					// .addIndicators( {name: "scroll"})
					.addTo(Controller.ScrollController)



					this.nextCloudScene = new ScrollMagic.Scene({
						triggerElement: cloud,
						triggerHook: 'onCenter',
						duration: this.getHeight(cloud)

					})
					// .addIndicators( {name: "scroll"})
					.addTo(Controller.ScrollController)

					if(this.flag) {


						this.cloudScene.on('enter', function(event){

							if($(cloud).hasClass('intro')) {
								LeafFall01.init();
							}
							if($(cloud).hasClass('recruit')) {
								LeafFall02.init();
							}
							if($(cloud).hasClass('works')) {
								Panel.init();
							}
						});

						this.cloudScene.on('leave', function() {
							if($(cloud).hasClass('intro')) {
								LeafFall01.stop();
							}
							if($(cloud).hasClass('recruit')) {
								LeafFall02.stop();
							}
							if($(cloud).hasClass('works')) {
								Panel.stop();
							}
						})



						this.nextCloudScene.on('progress', function(event){

							var t = event.progress;
							var move = null;
							if(Controller.device === 'PC') {
								move = Math.ceil(window.innerWidth * (transform / 1366));
							} else {
								move = Math.ceil(window.innerWidth * (transform / 750));
							}
							if(element != undefined) {

								$(element).css({
									'transform': 'translate3d(0,'+ (move - (Math.floor(t * move))) +'px ,0)'
								});
							}

						});
					}



					if(this.count - 1 === index) {
						this.flag = false;
					}


				}.bind(this));

			}
		}
	}

	Parallax.init();

	var LeafFall01 = {

		init: function() {
			if(!$('#fallArea01').get(0)) {
				return;
			}
			this.leafPattern = 3; // 葉のサイズパターン(0～3)
			this.swingPattern = 15; // 葉の揺れのパターン(0～15)
			this.addleafSpeed = 3000; // 葉を追加する間隔
			this.fallSpeedMin = 40; // 落下スピードの最小(秒速)
			this.fallSpeedMax = 80; // 落下スピードの最大(秒速)

			this.leafarea = document.getElementById('fallArea01'); // 葉を追加するエリア
			this.leafArr = []; // 葉を追加する配列
			this.leafCount = 0; // 葉をいくつ追加したかカウント

			this.leafVarsion = 1;

			// 一定時間毎に葉を追加
			this.timer = setInterval(function() {
				this.leafArr[this.leafCount] = this.createleaf(this.leafarea);
				this.leafarea.appendChild(this.leafArr[this.leafCount]);
				this.removeleaf(this.leafarea, this.leafArr[this.leafCount]);
				this.leafCount++;
				if(this.leafVarsion == 5) {
					this.leafVarsion = 1;
				} else {
					this.leafVarsion++;
				}
			}.bind(this), this.addleafSpeed);


		},
		stop: function() {
			// $('#fallArea01').children().remove();
			clearInterval(this.timer);
		},
		createleaf: function(area) {
			// ブラウザの幅と高さを取得
			var areaWidth = area.clientWidth;
			var areaHeight = area.clientHeight;

			// 葉で使用する各値を取得
			var className = 'leaf' + this.getRandomInt(0, this.leafPattern);
			var animationName = 'leafX' + this.getRandomInt(0, this.swingPattern);
			var swingSpeed = this.getRandomInt(1500, 3000) + 'ms';
			var fallSpeed = this.getRandomInt(Math.round(areaHeight / this.fallSpeedMax), Math.round(areaHeight / this.fallSpeedMin)) + 's';
			var StartPosition = this.getRandomInt(0, areaWidth) + 'px';

			// 葉の作成
			var leaf = document.createElement('div');
			leaf.className = className;
			leaf.style.left = '';
			leaf.setAttribute('style', 'left: ' + StartPosition + '; -webkit-animation-name: ' + animationName + ', leafY; animation-name: ' + animationName + ', leafY; -webkit-animation-duration: ' + swingSpeed + ', ' + fallSpeed + '; animation-duration: ' + swingSpeed + ', ' + fallSpeed + ';');



			$(leaf).addClass('varsion' + this.leafVarsion);


			// 作成した葉を返す
			return leaf;
		},
		removeleaf: function(area, leaf) {
			this.timeOutTimer = setTimeout(function() {
				leaf.parentNode.removeChild(leaf);
			}.bind(this), Math.round(area.clientHeight / this.fallSpeedMin) * 1000);
		},
		getRandomInt: function(min, max) {
			return Math.floor( Math.random() * (max - min + 1) ) + min;
		}

	}

	var LeafFall02 = {

		init: function() {
			if(!$('#fallArea02').get(0)) {
				return;
			}
			this.leafPattern = 3; // 葉のサイズパターン(0～3)
			this.swingPattern = 10; // 葉の揺れのパターン(0～15)
			this.addleafSpeed = 3000; // 葉を追加する間隔
			this.fallSpeedMin = 40; // 落下スピードの最小(秒速)
			this.fallSpeedMax = 80; // 落下スピードの最大(秒速)

			this.leafarea = document.getElementById('fallArea02'); // 葉を追加するエリア
			this.leafArr = []; // 葉を追加する配列
			this.leafCount = 0; // 葉をいくつ追加したかカウント

			this.leafVarsion = 1;

			// 一定時間毎に葉を追加
			this.timer = setInterval(function() {
				this.leafArr[this.leafCount] = this.createleaf(this.leafarea);
				this.leafarea.appendChild(this.leafArr[this.leafCount]);
				this.removeleaf(this.leafarea, this.leafArr[this.leafCount]);
				this.leafCount++;
				if(this.leafVarsion == 5) {
					this.leafVarsion = 1;
				} else {
					this.leafVarsion++;
				}
			}.bind(this), this.addleafSpeed);


		},
		stop: function() {
			clearTimeout(this.timeOutTimer);
			clearInterval(this.timer);
		},
		createleaf: function(area) {
			// ブラウザの幅と高さを取得
			var areaWidth = area.clientWidth;
			var areaHeight = area.clientHeight;

			// 葉で使用する各値を取得
			var className = 'leaf' + this.getRandomInt(0, this.leafPattern);
			var animationName = 'leafX' + this.getRandomInt(0, this.swingPattern);
			var swingSpeed = this.getRandomInt(1500, 3000) + 'ms';
			var fallSpeed = this.getRandomInt(Math.round(areaHeight / this.fallSpeedMax), Math.round(areaHeight / this.fallSpeedMin)) + 's';
			var StartPosition = this.getRandomInt(0, areaWidth - 50) + 'px';

			// 葉の作成
			var leaf = document.createElement('div');
			leaf.className = className;
			leaf.style.left = '';
			leaf.setAttribute('style', 'left: ' + StartPosition + '; -webkit-animation-name: ' + animationName + ', leafY; animation-name: ' + animationName + ', leafY; -webkit-animation-duration: ' + swingSpeed + ', ' + fallSpeed + '; animation-duration: ' + swingSpeed + ', ' + fallSpeed + ';');



			$(leaf).addClass('varsion' + this.leafVarsion);


			// 作成した葉を返す
			return leaf;
		},
		removeleaf: function(area, leaf) {
			this.timeOutTimer = setTimeout(function() {
				leaf.parentNode.removeChild(leaf);
			}.bind(this), Math.round(area.clientHeight / this.fallSpeedMin) * 1000);
		},
		getRandomInt: function(min, max) {
			return Math.floor( Math.random() * (max - min + 1) ) + min;
		}

	}


	if($('.top-page').get(0)) {
		var star_scene = new ScrollMagic.Scene({
			triggerElement: '.recruit',
			triggerHook: 'onCenter', //onCenter, onLeave
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		star_scene.setClassToggle('.star-frame', 'is-show');

		var river_scene01 = new ScrollMagic.Scene({
			triggerElement: '.intro-river',
			triggerHook: 'onCenter', //onCenter, onLeave
			duration: $('.intro-river').height()
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		river_scene01.on('progress', function(event){
			var t = event.progress;
			var move = null;
			if(Controller.device === 'PC') {
				move = Math.ceil(window.innerWidth * (200 / 1366));
			} else {
				move = Math.ceil(window.innerWidth * (200 / 750));
			}
			$('.intro-river .river-bg').css({
				'transform': 'translate3d(0,'+ (Math.floor(t * move)) +'px ,0)'
			});
		})

		var river_scene02 = new ScrollMagic.Scene({
			triggerElement: '.services-river01',
			triggerHook: 'onCenter', //onCenter, onLeave
			duration: $('.services-river01').height()
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		river_scene02.on('progress', function(event){
			var t = event.progress;
			var move = null;
			if(Controller.device === 'PC') {
				move = Math.ceil(window.innerWidth * (200 / 1366));
			} else {
				move = Math.ceil(window.innerWidth * (200 / 750));
			}
			$('.services-river01 .river-bg').css({
				'transform': 'translate3d(0,'+ (Math.floor(t * move)) +'px ,0)'
			});
		})

		var river_scene03 = new ScrollMagic.Scene({
			triggerElement: '.services-river02',
			triggerHook: 'onCenter', //onCenter, onLeave
			duration: $('.services-river02').height()
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		river_scene03.on('progress', function(event){
			var t = event.progress;
			var move = null;
			if(Controller.device === 'PC') {
				move = Math.ceil(window.innerWidth * (200 / 1366));
			} else {
				move = Math.ceil(window.innerWidth * (200 / 750));
			}
			$('.services-river02 .river-bg').css({
				'transform': 'translate3d(0,'+ (Math.floor(t * move)) +'px ,0)'
			});
		});

		var river_scene04 = new ScrollMagic.Scene({
			triggerElement: '.recruit-river',
			triggerHook: 'onCenter', //onCenter, onLeave
			duration: $('.recruit-river').height()
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		river_scene04.on('progress', function(event){
			var t = event.progress;
			var move = null;
			if(Controller.device === 'PC') {
				move = Math.ceil(window.innerWidth * (200 / 1366));
			} else {
				move = Math.ceil(window.innerWidth * (200 / 750));
			}
			$('.recruit-river .river-bg').css({
				'transform': 'translate3d(0,'+ (Math.floor(t * move)) +'px ,0)'
			});
		})

		var footer_scene = new ScrollMagic.Scene({
			triggerElement: '.trigger-border',
			triggerHook: 'onCenter', //onCenter, onLeave
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		.setClassToggle('.footer .circle','is-active')

		var city_scene = new ScrollMagic.Scene({
			triggerElement: '.city-trigger',
			triggerHook: 'onEnter', //onCenter, onLeave
		})
		// .addIndicators( {name: "scroll"})
		.addTo(Controller.ScrollController)
		.setClassToggle('.footer .city','is-active')

	}



	Contact.init();

	Recruit.init();


})(jQuery, Extension);
